/**
 * Regex Utilities
 * 
 * Utility functions for regex operations
 */

/**
 * Escapes special regex characters in a string to make it safe for use in RegExp
 * This is a lightweight implementation similar to lodash's escapeRegExp
 * @param string - The string to escape
 * @returns Escaped string safe for regex
 */
export const escapeRegExp = (string: string): string => {
  if (!string) return '';
  
  // Escape special regex characters: ^$.*+?()[]{}|\
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};
